import { render, staticRenderFns } from "./AttendanceChart.vue?vue&type=template&id=1472c3b4&scoped=true&"
import script from "./AttendanceChart.vue?vue&type=script&lang=js&"
export * from "./AttendanceChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1472c3b4",
  null
  
)

export default component.exports